<template>
  <dropdown-menu
      v-model="show"
      interactive
    >
    <button class="toggle text-nowrap">
      {{ label }}
      <span class="toggle-count" v-if="optionsSelectedCount">
        {{ optionsSelectedCount }}
      </span>
    </button>
    <div slot="dropdown">
      <div class="dropdown-options">
        <b-form-input
          class="dropdown-item searcher"
          size="sm"
          placeholder="Buscar..."
          v-model="search"
        ></b-form-input>
        <div class="dropdown-options-container">
          <span
            v-for="(item, index) in optionsFiltered"
            :key="index"
            class="dropdown-item"
            :class="{ 'selected': item.selected }"
            @click="onClick(item)"
          >
            <span class="d-flex justify-content-between">
              <span class="dropdown-item-label">{{ item.name }}</span>
              <i class="mdi mdi-check" v-if="item.selected"></i>
            </span>
          </span>
        </div>
      </div>
    </div>
  </dropdown-menu>
</template>

<script>
// Components
import DropdownMenu from '@innologica/vue-dropdown-menu'

// Utils
import commonsApi from '@/api/commons'

export default {
  props: {
    label: String,
    optionsPath: String,
    pick: {
      type: Array,
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: true
    }
  },
  components: {
    DropdownMenu
  },
  data () {
    return {
      show: false,
      search: '',
      options: []
    }
  },
  computed: {
    optionsSelectedCount () {
      return this.options.filter(el => el.selected).length
    },
    optionsSelected () {
      return this.options.filter(el => el.selected)
        .map(el => {
          return {
            id: el.id,
            name: el.name,
            value: el.value
          }
        })
    },
    optionsFiltered () {
      return this.options.filter(el => {
        return el.name.toLowerCase().search(this.search.toLowerCase()) >= 0
      })
    }
  },
  methods: {
    async loadOptions () {
      try {
        const res = await commonsApi.axiosGetWrapper(this.optionsPath)
        this.options = res.data.items.map(el => {
          return {
            ...el,
            selected: false
          }
        })
      } catch (error) {
        console.log(error)
      }
    },
    loadPickedOptions () {
      if (this.pick.length) {
        const picks = this.pick.map(el => el.id)
        this.options.forEach(el => {
          if (picks.includes(el.id)) {
            el.selected = true
          }
        })
      }
    },
    onClick (item) {
      if (!this.multiple) {
        this.options = this.options.map(el => {
          if (el.id !== item.id) el.selected = false
          return el
        })
      }
      item.selected = !item.selected
      this.$emit('change', this.optionsSelected)
    }
  },
  async created () {
    await this.loadOptions()
    await this.loadPickedOptions()
  }
}
</script>

<style lang="sass" scoped>
  button.toggle
    display: flex
    gap: 10px
    background-color: #e9ecef
    border: 0
    padding: .5rem .8rem
    border-radius: 8px
    .toggle-count
      background-color: white
      display: flex
      justify-content: center
      align-items: center
      width: 21px
      height: 21px
      border-radius: 50%
  .dropdown-options
    .dropdown-options-container
      max-height: 400px
      overflow-y: auto
      margin: 2px 0
      &:hover
        &::-webkit-scrollbar-thumb
          border-radius: 20px
          background: #888
      &::-webkit-scrollbar
        width: 8px
      &::-webkit-scrollbar-thumb
        border-radius: 20px
        background: #888
      &::-webkit-scrollbar-thumb:hover
        background: #555
    .dropdown-item
      &.searcher
        background-color: #e9ecef
        margin-bottom: .5rem
        &:focus
          box-shadow: none
      &:active
        background-color: #e9ecef
        color: #212529
      &.selected
        background-color: #e9ecef
        .dropdown-item-label
          margin-right: 15px
      .dropdown-item-label
          margin-right: 31px
      i.mdi
        height: 24px
</style>
